import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { getImagesUrl } from "../../redux/common";
import FragmentCardContent from "./FragmentCardContent";

export function ElementForbidden() {
    const navigate = useNavigate();

    return <>
        <FragmentCardContent 
            image={`${getImagesUrl()}/forbidden.webp`}
            title="Acesso não autorizado"
            description={
                <Box>
                    <Box>Acesso a este registro não autorizado</Box>
                    <Button onClick={() => navigate(-1)}>Voltar</Button>
                    <Button onClick={() => navigate("/")}>Inicio</Button>
                </Box>
            }
        />
    </>;
}